import type MarkdownIt from 'markdown-it';
import Token from 'markdown-it/lib/token';

const QUERY_REGEX = /\[toc\]/;

function isQuery(token: Token) {
	return token.content?.match(QUERY_REGEX);
}

export default function tableOfContents(md: MarkdownIt) {
	// Insert a new rule after the "inline" rules are parsed.
	md.core.ruler.after('inline', 'toc', (state) => {
		const { tokens } = state;

		for (let i = tokens.length - 1; i > 0; i -= 1) {
			const tokenChildren = tokens[i].children || [];
			const matches = tokenChildren.filter(isQuery);

			if (matches.length && matches.length > 0) {
				let token;

				const nodes: Token[] = [];

				token = new Token('toc_open', '', 1);
				nodes.push(token);

				const text = new Token('text', '', 0);
				text.content = '';
				nodes.push(text);

				token = new Token('toc_close', '', -1);
				nodes.push(token);
				tokens.splice(i - 1, 3, ...nodes);

				break;
			}
		}

		return false;
	});
}
